import React from "react";
import PageWithCard from "../../components/infrastructure/PageWithCard";
import { useFormik } from "formik";
import FormikInputGroup from "../../components/formik/FormikInputGroup";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import ModalBasic from "../../components/infrastructure/Modals/ModalBasic";
import { useDispatch } from "react-redux";
import { editCommittee, fetchCommittees } from "../../app/reducers/Committee/committeeSlice";
import { createWebsiteCreativeData } from "../../app/reducers/WebsitesCreatives/websitesCreativeSlice";

const WarOfCLChangeableModal = (
    {
        woClData,
        showWarOfClEditModal,
        setShowWarOfClEditModal,
        refetch,
    }
)=>{
    const dispatch = useDispatch();
    const formik = useFormik({
        enableReinitialize : true,
        initialValues : {
            ...woClData
        },
        onSubmit:async(values)=>{
            try {
                const obj = {
                    name : 'WarOfCl',
                    ...values
                }
                const resp = await dispatch(createWebsiteCreativeData(obj));
        
                if(resp?.payload?.success){
                    await refetch('WarOfCl')
                    setShowWarOfClEditModal(false);
                }
                
            } catch (error) {
                console.log('Error in update war of cl title', error)
            }
        }
    })

    return(
        <ModalBasic
            modalOpen={showWarOfClEditModal}
            setModalOpen={setShowWarOfClEditModal}
            title={'War Of CL Changeable'}
        >
            <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-4  bg-black p-4 rounded sm:rounded-md"
            >
                <FormikInputGroup
                    label="Title"
                    name="warOfClTitle"
                    formik={formik}
                    required
                />
                <FormikInputGroup
                    label="Color Code"
                    name="warOfClHexCode"
                    formik={formik}
                    required
                />
                <div>
                    <PrimaryButton type="submit">Update</PrimaryButton>
                </div>
            </form>
        </ModalBasic>

    )
}

export default WarOfCLChangeableModal;

